module.exports = __webpack_public_path__ + "img/ba7acd4.jpg";